module.exports = __webpack_public_path__ + "img/logo_defillama.3c07b5c5.png";